import { ISPV, ISPVBalance } from '@appInterfaces/spv.interfaces';
import { ESpvStatus } from '@enums/ESpv';

class SPVMockServiceClass {
  public getSPVs(company_id = 200): ISPV[] {
    return [
      {
        company_id,
        id: 1345,
        name: 'BnkToTheFuture Bitfinex SP',
        description: 'Lorem ipusm bla bla bla',
        last_trade_price: '34.54',
        status: ESpvStatus.trading,
        estimated_share_values: [],
        estimated_share_value_description: '',
        trading_asset_id: 23,
        assets: [
          { id: 23, share_type: 'b' },
          { id: 24, share_type: 'a' },
        ]
      },
      {
        company_id,
        id: 1400,
        name: 'BnkToTheFuture Kraken SP',
        description: 'Lorem ipusm bla bla bla',
        last_trade_price: '12.64',
        status: ESpvStatus.trading,
        estimated_share_values: [],
        estimated_share_value_description: '',
        trading_asset_id: 30,
        assets: [
          { id: 31, share_type: 'a' },
        ]
      },
      {
        company_id,
        id: 1500,
        name: 'BnkToTheFuture ShapeShift SP',
        description: 'Lorem ipusm bla bla bla',
        last_trade_price: '4.54',
        status: ESpvStatus.pending,
        estimated_share_values: [],
        estimated_share_value_description: '',
        trading_asset_id: 500,
        assets: [
          { id: 500, share_type: 'b' },
        ]
      },
      {
        id: 1600,
        name: 'BnkToTheFuture CornHub SP',
        company_id: 342,
        description: 'Lorem ipusm bla bla bla',
        last_trade_price: '2.54',
        status: ESpvStatus.suspended,
        estimated_share_values: [],
        estimated_share_value_description: '',
        trading_asset_id: 700,
        assets: [
          { id: 506, share_type: 'a' },
        ]
      }
    ];
  }

  public getAssetBalances = (asset_id: number = 100): ISPVBalance[] => {
    return [{
      asset_id,
      id: 10,
      amount: '0.0',
      investor_id: 1565,
    }, {
      asset_id,
      id: 11,
      amount: '540.1205',
      investor_id: 1565,

    }, {
      id: 12,
      asset_id: 23,
      amount: '23.15',
      investor_id: 1565,
    }, {
      id: 13,
      asset_id: 24,
      amount: '34.165',
      investor_id: 1565,
    }]
  }
}

const SPVMockService = new SPVMockServiceClass();

export default SPVMockService;
